import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formSchemas } from '../formSchemas.js';
import axios from 'axios';
import CustomerForm from '../Components/CustomerForm.jsx';
import ProgressBar from '../Components/ProgressBar.jsx';

const validateRoute = process.env.REACT_APP_VALIDATE_INVITE;
const customerSubmissionRoute = process.env.REACT_APP_CUSTOMER_SUBMISSION;

export default function InviteFormPage() {
  const [invite, setInvite] = useState(null);
  const [error, setError]   = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');

  console.log("InviteFormPage mounted")


  useEffect(() => {



  if (!token) {
      setError('Missing token');
      setLoading(false);
      return;
    }

      setProgress(0);
  let val = 0;
  const interval = setInterval(() => {
    val += 5;
    setProgress((p) => (p < 90 ? p + 5 : p)); // stop at 90 until real finish
  }, 200);

  axios.post(validateRoute, { token })
    .then(res => {
        const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
        setInvite({ ...parsed, token });
    })
    .catch(err => {
      console.error(err);
      setError(err.response?.data || err.message);
    }).finally(() => {
        clearInterval(interval);
        setProgress(100);
        setLoading(false);
        setTimeout(() => setLoading(false), 400);
    });

    return () => clearInterval(interval);
  }, [token]);

  if (loading) return <ProgressBar progress={progress} text={`Checking your invitation… ${progress}%`} />;

  if (error) return <p style={{color: 'red'}}>{error}</p>;
  if (!invite) return <p>No invite loaded</p>;

const {
  applicantId,
  ApplicationType,
  CustomerName,
  CustomerEmail,
  CustomerType,
  CurrentAccount
} = invite || {};

const schemaSections = formSchemas[ApplicationType];

if (!schemaSections) {
  console.error('❌ Unknown form type:', ApplicationType);
  console.log('Available keys:', Object.keys(formSchemas));
}

  if (!schemaSections) return <p>Unknown form type: {invite.ApplicationType}</p>;


    const handleSubmit = async (answers) => {
      setSubmitting(true);
      setProgress(0);
    
      try{
        await axios.post(customerSubmissionRoute, {
          token,
          answers
        },      {
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percent);
          }
        }
      });
        alert('Submitted! Thanks.');
      } catch (error) {
        console.error('Submission error:', error);
        alert('Failed to submit. Please try again later.');
      } finally {
        setSubmitting(false);
      }
    };

    if (submitting) return <ProgressBar progress={progress} text={`Uploading... ${progress}%`} />
    if (!invite) return <p>Waiting for invite context…</p>;


  return (
    <div>
      {submitting && <p>Submitting… please wait</p>}
      <CustomerForm
        schemaSections={schemaSections}
        onSubmit={handleSubmit}
        initialValues={{
          customerName:  CustomerName,
          customerEmail: CustomerEmail,
          customerType:  CustomerType,
          currentAccount: CurrentAccount,
          includeShipping: false,
        }}
        applicationType={ApplicationType}
        applicantId={applicantId}
        token={token}
      />
    </div>
  );
}
